import React from 'react'
import { observer } from 'mobx-react'
import { useParams } from 'react-router'
import { Button, Spin } from 'antd'
import { t } from '../../../config/i18n'
import { routes } from '../../../config/routes'
import { hasAccess } from '../../../lib/utilsCatalogs'
import { useNavigate } from '../../../hooks/useNavigate'
import { CatalogBindings } from '../../shared/ui/CatalogBindings'
import { PERMISSIONS } from '../../../models/AbstractCatalogConfig'
import { TCatalogBindingItem } from '../../../models/CatalogBindingItem'
import { AbstractCatalogService } from '../../../services/AbstractCatalogService'
import styles from './TabBindings.module.scss'

interface Props {
  catalogService: AbstractCatalogService<any, any>
}

export const PageCatalogItemDetailTabBindings = observer(({ catalogService }: Props) => {
  const navigate = useNavigate()
  const { type, id, parentId } = useParams()
  const [loading, setLoading] = React.useState(true)
  const [bindings, setBindings] = React.useState<TCatalogBindingItem[]>([])

  const catalogConfig = catalogService.store.configItemDetails
  const catalogItem = catalogService.store.itemDetails

  React.useEffect(() => {
    setLoading(true)
    catalogService.getBindings(catalogConfig.id, catalogItem._id)
      .then(setBindings)
      .finally(() => setLoading(false))
  }, [catalogConfig.id, catalogItem.id])

  const onSave = React.useCallback(async () => {
    if (await catalogService.setBindings(catalogConfig.id, catalogItem._id, bindings)) {
      navigate(routes.catalogItemList, { type, id: id || '', parentId })
    }
  }, [catalogConfig.id, catalogItem.id, bindings])

  const disabled = !hasAccess(catalogConfig, PERMISSIONS.BINDING)

  if (loading) {
    return (
      <div className={styles.root}>
        <div className={styles.loader}>
          <Spin size={'large'} />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <CatalogBindings
        catalogConfig={catalogConfig}
        catalogItem={catalogItem}
        bindings={bindings}
        onChange={setBindings}
      />

      <Button
        className={styles.save}
        disabled={disabled}
        type="primary"
        onClick={onSave}
      >
        {t.common.save}
      </Button>
    </div>
  )
})
